import type { Community } from '@communities/community/domain';
import { HeroImage } from '@core/components';
import { Card, Heading, Text } from '@soteria/design-system-ve';

import * as styles from './CommunityCard.css.ts';

interface CommunityCardProps {
  community: Community;
  isSelected: boolean;
  onClick: (community: Community) => void;
}

/**
 * Card component for displaying a community
 */
export function CommunityCard({ community, isSelected, onClick }: CommunityCardProps) {
  // Get the description text
  const descriptionText = community.optionalMetadata?.description || 'No description available';

  return (
    <Card
      className={styles.cardContainer}
      elevation={isSelected ? 'high' : 'medium'}
      isSelected={isSelected}
      padding="none"
      width="full"
      onSelect={() => onClick(community)}
    >
      <HeroImage logoUrl={community.logoUrl} name={community.name} size="card" />

      <div className={styles.contentContainer}>
        <Heading className={styles.communityTitle} level="h2" size="xl" weight={isSelected ? 'bold' : 'semibold'}>
          {community.name}
        </Heading>

        <Text className={styles.communityDescription} color="secondary" size="sm">
          {descriptionText}
        </Text>
      </div>
    </Card>
  );
}
